import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import Horoscope from './components/Horoscope';
import { useDispatch, useSelector } from 'react-redux';
import {
  countryCodes,
  stateCodes,
  citieslist,
  get_byID,
  starlist,
  rasilist
} from './redux/slice';
import { pageview } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title = 'Horoscope & Kundli details ';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const { country_codes } = useSelector((state) => state.editprofile);
  const { state_details, city_details, star_details, rasi_details } =
    useSelector((state) => state.edithoroscope);

  const { user_data } = useSelector((state) => state.listDashboard);

  // console.log('state_details', city_details);

  useEffect(() => {
    get_countryCodes();
    get_states();
    get_cities();
    get_listby_id();
    get_star_list();
    get_rasi_list();
  }, []);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };

  const get_states = () => {
    dispatch(stateCodes());
  };

  const get_cities = () => {
    dispatch(citieslist());
  };

  const get_star_list = () => {
    dispatch(starlist());
  };

  const get_rasi_list = () => {
    dispatch(rasilist());
  };
  return (
    <>
      <Layout sider={true}>
        <Horoscope
          country_codes={country_codes}
          state_details={state_details}
          city_details={city_details}
          user_data={user_data}
          star_details={star_details}
          rasi_details={rasi_details}
        />
      </Layout>
    </>
  );
};

export default index;
